import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, InputAdornment, Box } from '@mui/material';
import { BusinessOutlined } from '@mui/icons-material';
import { useCpsiAccessEditor } from '../../../../hooks/useCpsiAccessEditor';
import { useGetCpsiCentersQuery } from '../../../../../../services/DimensionService/dimensionApi';
import { EditorMode } from '../../../../types/editorTypes';

interface Props {
  mode: EditorMode;
}

export const CpsiCenterEditor: React.FC<Props> = ({ mode }) => {
  const { request, updateRequest } = useCpsiAccessEditor(mode);
  const { data: cpsiCenters = [], isLoading } = useGetCpsiCentersQuery();
  const labelId = `${mode}-cpsi-center-label`;

  const handleChange = (value: string) => {
    updateRequest({ center: value });
  };

  return (
    <Box sx={{ flex: 1 }}>
      <FormControl size="small" fullWidth required>
        <InputLabel id={labelId}>Center</InputLabel>
        <Select
          labelId={labelId}
          value={request?.center || ''}
          onChange={(e) => handleChange(e.target.value)}
          label="Center"
          disabled={isLoading}
          startAdornment={
            <InputAdornment position="start">
              <BusinessOutlined sx={{ color: '#64748b', fontSize: 18 }} />
            </InputAdornment>
          }
        >
          {cpsiCenters.map((center) => (
            <MenuItem key={center.value} value={center.value}>
              {center.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default CpsiCenterEditor;
